"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_TRANSLATIONS = void 0;
const date_1 = require("./date");
const dateAdd_1 = require("./dateAdd");
const dateFormat_1 = require("./dateFormat");
const day_1 = require("./day");
const isDate_1 = require("./isDate");
const month_1 = require("./month");
const today_1 = require("./today");
const weekDay_1 = require("./weekDay");
const weekNum_1 = require("./weekNum");
const year_1 = require("./year");
const dateValue_1 = require("./dateValue");
const dateDif_1 = require("./dateDif");
const eomonth_1 = require("./eomonth");
const dateOnly_1 = require("./dateOnly");
const bimester_1 = require("./bimester");
const quarter_1 = require("./quarter");
const semester_1 = require("./semester");
__exportStar(require("./date"), exports);
__exportStar(require("./dateAdd"), exports);
__exportStar(require("./dateFormat"), exports);
__exportStar(require("./day"), exports);
__exportStar(require("./isDate"), exports);
__exportStar(require("./month"), exports);
__exportStar(require("./weekDay"), exports);
__exportStar(require("./weekNum"), exports);
__exportStar(require("./year"), exports);
__exportStar(require("./dateDif"), exports);
__exportStar(require("./dateValue"), exports);
__exportStar(require("./eomonth"), exports);
__exportStar(require("./dateOnly"), exports);
__exportStar(require("./bimester"), exports);
__exportStar(require("./quarter"), exports);
__exportStar(require("./semester"), exports);
exports.DATE_TRANSLATIONS = {
    DATEADD: dateAdd_1.DATEADD,
    DATEFORMAT: dateFormat_1.DATEFORMAT,
    ISDATE: isDate_1.ISDATE,
    DAY: day_1.DAY,
    WEEKDAY: weekDay_1.WEEKDAY,
    WEEKNUM: weekNum_1.WEEKNUM,
    MONTH: month_1.MONTH,
    YEAR: year_1.YEAR,
    DATE: date_1.DATE,
    TODAY: today_1.TODAY,
    DATEVALUE: dateValue_1.DATEVALUE,
    DATEDIF: dateDif_1.DATEDIF,
    EOMONTH: eomonth_1.EOMONTH,
    DATEONLY: dateOnly_1.DATEONLY,
    BIMESTER: bimester_1.BIMESTER,
    QUARTER: quarter_1.QUARTER,
    SEMESTER: semester_1.SEMESTER,
};
